import { render } from "./TemplateSlugForm.vue?vue&type=template&id=551dd39c&ts=true"
import script from "./TemplateSlugForm.vue?vue&type=script&lang=ts"
export * from "./TemplateSlugForm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3662402436/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__